/**
 * PAPPO — Moderation service (punições, F3).
 * Staff aplica/lista/revoga punições (/api/staff/...); o próprio usuário vê e
 * reconhece suas advertências (/api/users/me/warnings).
 */
import { apiGet, apiPost } from './api';

export type PunishmentType = 'warning' | 'mute' | 'suspend' | 'ban';

export const PUNISH_LABEL: Record<PunishmentType, string> = {
  warning: 'Advertência',
  mute: 'Silenciar',
  suspend: 'Suspender',
  ban: 'Banir',
};

export interface PunishmentItem {
  id: number;
  type: PunishmentType;
  reason: string | null;
  created_at: string;
  expires_at: string | null;
  active: boolean;
  em_efeito: boolean;
  acknowledged: boolean;
  lifted_at: string | null;
  report_id: number | null;
  issued_name: string | null;
  lifted_name: string | null;
}

export interface ApplyPunishment {
  type: PunishmentType;
  reason: string;
  report_id?: number;
  duration_horas?: number;
}

/** Staff: aplica uma punição sobre um adulto. */
export async function punishUser(targetId: number, body: ApplyPunishment) {
  return apiPost<{ id: number }>(`/staff/users/${targetId}/punish`, body);
}

/** Staff: histórico de punições de um usuário (ativas + passadas). */
export async function listPunishments(targetId: number) {
  return apiGet<{ punishments: PunishmentItem[] }>(
    `/staff/users/${targetId}/punishments`
  );
}

/** Staff: revoga (levanta) uma punição ativa. */
export async function liftPunishment(punishmentId: number) {
  return apiPost(`/staff/punishments/${punishmentId}/lift`, {});
}

// ── Advertências do próprio usuário ────────────────────────────
export interface MyWarning {
  id: number;
  reason: string | null;
  created_at: string;
  issued_name: string | null;
}

/** Advertências ainda não reconhecidas pelo usuário atual. */
export async function listMyWarnings() {
  return apiGet<{ warnings: MyWarning[] }>('/users/me/warnings');
}

/** Marca uma advertência como vista (some do aviso). */
export async function ackWarning(punishmentId: number) {
  return apiPost(`/users/me/warnings/${punishmentId}/ack`, {});
}
